export enum FEATURED_TAGS {
  HOW_TOS = 'how-tos',
  COMPARISONS = 'comparisons',
  EXPERT_ADVICE = 'expert-advice',
  GUIDES = 'guides',
  TOP_LISTS = 'top-lists',
}

export const FEATURED_TAG_SLUGS = Object.values(FEATURED_TAGS);

export const FEATURED_TAG_SLUGS_TO_CMS_TAG: Record<string, string> = {
  [FEATURED_TAGS.HOW_TOS]: "How To's",
  [FEATURED_TAGS.COMPARISONS]: 'Comparisons',
  [FEATURED_TAGS.EXPERT_ADVICE]: 'Expert Advice',
  [FEATURED_TAGS.GUIDES]: 'Guides',
  [FEATURED_TAGS.TOP_LISTS]: 'Top Lists',
};
